import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import LogoIso from "src/components/LogoIso";

import Context from "../context";

// ----------------------------------------------------------------------

export const Powered = () => {
	const { values } = useContext(Context);

	return (
		<Stack flexDirection={"row"} alignItems='center' justifyContent={"center"} mt={4} mb={-1}>
			<Typography
				variant='body1'
				color={values.secondaryTextColor}
				fontSize={{ sm: 13, xs: 11 }}
				sx={{ mr: 1 }}
			>
				{"Powered by"}
			</Typography>
			<LogoIso width={60} height={20} sx={{ mt: 0.7 }} disabledLink />
		</Stack>
	);
};

export default Powered;
